import { flatten } from 'lodash';
import { useLiveVotingSessions } from "./useLiveVotingSessions";
import { useProgramLiveVoting } from "./useProgramLiveVoting";
/**
 * Selects open live voting sessions that should be auto opened when streaming is open
 * @param  {Number} eventId   Event ID
 * @param  {Number} programId Program open in networkarea
 * @return {array}            Array of valid voting sessions
 */

export function useAutoOpenableLiveVoting(eventId, programId) {
    const programLessVotingSessions = useLiveVotingSessions(eventId, (session) => !session.program_id),
        programVotingSessions = useProgramLiveVoting(eventId, programId);
    return flatten([...programVotingSessions, ...programLessVotingSessions]).filter((session) => session?.is_open);
}
